import _ from "lodash";
import React from "react";
import styled from "styled-components";
import ty from "../styled-tachyons";
import {
  ArrowButton,
  ColThird,
  ColTwoThirds,
  FlexRow,
  Image,
  nsQuery,
  lQuery,
  rem,
  DarkGraySection,
} from "../styles";
import { InfoCard } from "../components/InfoCard";

export const CarouselSection = styled(DarkGraySection)`
  ${ty`pt0-l`};
  ${FlexRow} {
    ${ty`pb5-l`};
  }
`;
const ArrowActions = styled.div`
  ${ty`flex mb5 justify-end`}
  ${lQuery} {
    max-width: ${rem(379)};
    ${ArrowButton}:first-child {
      ${ty`mr2`}
    }
  }
`;
const CarouselControls = styled.div`
  ${ty`flex flex-row flex-wrap flex-nowrap-l flex-column-l center mw6 z-2 relative mt7-l`};
  transform: translateZ(5px);
  ${InfoCard} {
    flex-grow: 1;
    ${ty`mr1`};
    order: 1;
  }
  ${ArrowActions} {
    order: 2;
    width: ${rem(72)};
    ${ty`flex flex-row w-100 mt4 mt0-l`};
    text-indent: -99999px;

    ${ArrowButton} {
      ${ty`justify-center center mh0-l ph3`};
      &:after {
        margin: 0;
      }
      &:first-child {
        ${ty`mr2`};
      }
    }
  }

  ${nsQuery} {
    ${ArrowButton} {
      &:first-child:after {
        ${ty`mr3`};
      }
      &:last-child:after {
        ${ty`ml3`};
      }
    }
    ${ArrowActions} {
      text-indent: unset;
    }
  }

  ${lQuery} {
    ${InfoCard} {
      order: 2;
    }
    ${ArrowActions} {
      order: 1;
      width: auto;
    }
  }
`;
const CarouselPages = styled.div`
  position: relative;
  perspective: 100;
  transform-style: preserve-3d;
  ${ty`z-1 mt4-l`}
`;
const CarouselPage = styled.div`
  display: ${(p) => (!p.current ? "none" : "")};
  height: ${rem(320)};

  ${ty`w-100`}
  ${Image} {
    ${ty`mw-100`}
    height: 100%;
    max-height: ${rem(400)};
  }

  .placeholder {
    width: 100%;
  }
  ${nsQuery} {
    ${Image} {
      height: 500px;
    }
  }
  ${lQuery} {
    height: auto;
    ${Image} {
      max-height: 100%;
    }

    display: block;
    position: absolute;
    ${ty`mw-100`}
    .placeholder {
      width: 400px;
    }
  }
`;
export const Carousel = ({ projects = [], getCardTitle }) => {
  let [currentProjectIndex, setCurrentProjectIndex] = React.useState(
    projects.length - 1
  );

  let numPages = 3;

  let projectWindow = [...projects, ...projects, ...projects]
    .slice(
      currentProjectIndex - numPages + 1 + projects.length,
      currentProjectIndex + 1 + projects.length
    )
    .reverse();

  //let startI = _.findIndex(projects, projectWindow[numPages - 1]);

  // console.log({ projectWindow, currentProjectIndex, projects, startI });
  let pages = projectWindow.map(
    ({ imageUrl, artistName, projectTitle, projectUrl }, i) => {
      let offset =
        projectWindow.length -
        ((projectWindow.length - (numPages - i)) % projectWindow.length);

      let style = {
        zIndex: offset,
        // transform: `translateZ(${offset}px)`,
        transition:
          "filter 0.25s ease-out, left 0.25s ease-in, top 0.25s ease-in, transform 0.25s ease-in",
        left: offset * 15,
        top: offset * 15,
      };

      const isCurrent = i === 0;
      return (
        <CarouselPage key={i} style={style} current={isCurrent}>
          <Image fluid={_.get(imageUrl, "childImageSharp.fluid")} />
        </CarouselPage>
      );
    }
  );

  const goBack = React.useCallback(() => {
    let arrayLength = projects.length;
    setCurrentProjectIndex((currentIndex) => {
      return currentIndex - 1 < 0 ? arrayLength - 1 : currentIndex - 1;
    });
  }, [projects]);
  const goForward = React.useCallback(() => {
    let arrayLength = projects.length;
    setCurrentProjectIndex((currentIndex) => {
      return (currentIndex + 1) % arrayLength;
    });
  }, [projects]);
  // console.log({ currentProjectIndex });
  let currentProject = projects[currentProjectIndex];
  //console.log(currentProject);
  let { title, subTitle, subSubTitle } = currentProject;

  let cardTitle = getCardTitle?.(currentProject);

  let controls = (
    <CarouselControls>
      <ArrowActions>
        <ArrowButton
          css={ty`b--white bg-near-black washed-red`}
          arrowColor="red"
          onClick={goBack}
          arrowDirection="left"
        >
          Prev
        </ArrowButton>
        <ArrowButton
          css={ty`bg-near-black white b--washed-red`}
          arrowColor="white"
          onClick={goForward}
        >
          Next
        </ArrowButton>
      </ArrowActions>
      <InfoCard
        cardTitle={cardTitle}
        title={title}
        subTitle={subTitle}
        subSubTitle={subSubTitle}
        actionUrl={currentProject.projectUrl}
      />
    </CarouselControls>
  );

  return (
    <CarouselSection full>
      <FlexRow>
        <ColTwoThirds>
          <CarouselPages>{pages}</CarouselPages>
        </ColTwoThirds>
        <ColThird>{controls}</ColThird>
      </FlexRow>
    </CarouselSection>
  );
};
